import { formInputStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            inputSelect: css`
                ${formInputStyles()}
            `,
        },
    },
};
